import React from 'react';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { format, min } from 'date-fns';
import { Dialog, DialogTitle, DialogContent, DialogActions, 
    Button, TextField 
} from '@mui/material';


const BankTransferDialog = ({ 
    open, 
    onClose, 
    crewCode, 
    selectedFlights 
}) => {
    const params = useSelector((state) => state.auth.params);
    const IATA_AIRLINE_CODE = params?.find((item) => item.param === "IATA_AIRLINE_CODE")?.value || 'QH';
        
    const formattedFlightDate = selectedFlights?.length
        ? format(min(selectedFlights.map(f => new Date(f.flightDate))), 'dd.MM.yyyy')
        : '';

    const paddedCrewCode = crewCode.length <= 4 
        ? crewCode.padStart(4, '0') 
        : crewCode;

    const content = `IF${paddedCrewCode} ${formattedFlightDate} ${IATA_AIRLINE_CODE}${selectedFlights?.map(f => f.flightNo).join(".")}`;
    
    const handleCopy = async () => {
        if (navigator.clipboard && window.isSecureContext) {
            try {
                await navigator.clipboard.writeText(content);
                toast.success('Copied! Paste it to bank transfer.');
            } catch (error) {
                toast.error('Clipboard access failed! Copy manually.');
            }
        } else {
            const textarea = document.createElement('textarea');
            textarea.value = content;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            try {
                const successful = document.execCommand('copy');
                if (successful) {
                    toast.success('Copied! Paste it to bank transfer.');
                } else {
                    toast.error('Copying failed! Copy manually.');
                }
            } catch (fallbackError) {
                toast.error('Copying not supported! Copy manually.');
            } finally {
                document.body.removeChild(textarea);
            }
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Copy and paste it into your bank transfer</DialogTitle>
            <DialogContent>
                <TextField
                    fullWidth
                    value={content}
                    variant="outlined"
                    multiline
                    rows={2}
                    InputProps={{ readOnly: true }}
                    sx={{ marginTop: 2 }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCopy} color="primary" variant="outlined">
                    Copy
                </Button>
                <Button onClick={onClose} color="secondary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default BankTransferDialog;